import { dashboard } from '../../../lib/apiList'
import axios from '../../../lib/axios'
import { Query, Filter } from '../types'

export const dashboardstats = (): Promise<any> => {
    const response = axios.get(dashboard.STATS)
    return response
}

export const personalTimeOff = (
    pageSize: number,
    pageNumber: number,
    userid: string
): Promise<any> => {
    const data: Query = {
        advancedSearch: {
            fields: [],
            keyword: '',
        },
        keyword: '',
        advancedFilter: {
            logic: 'and',
            filters: [
                {
                    field: 'UserID',
                    operator: 'eq',
                    value: userid,
                },
                {
                    field: 'CreatedBy',
                    operator: 'eq',
                    value: userid,
                },
            ],
            field: '',
            operator: '',
            value: '',
        },
        pageNumber: pageNumber,
        pageSize: pageSize,
        orderBy: ['CreatedOn desc'],
        personalAppliedLeaves: true,
        assignedLeavesToMe: false,
        upcmoingLeaveOfUser: false,
        pastLeaveOfUser: false,
        userId: null,
    }
    const response = axios.post(dashboard.TIMEOFF, data)
    return response
}

export const assignedTimeOff = (
    pageSize: number,
    pageNumber: number,
    filters?: Filter[],
    logic?: string
): Promise<any> => {
    const data: Query = {
        advancedSearch: {
            fields: [],
            keyword: '',
        },
        keyword: '',
        advancedFilter:
            filters && filters?.length > 0
                ? {
                      logic: logic !== undefined && logic !== null ? logic : '',
                      filters: filters ?? [],
                      field: '',
                      operator: '',
                      value: '',
                  }
                : null,
        pageNumber: pageNumber,
        pageSize: pageSize,
        orderBy: ['CreatedOn desc'],
        personalAppliedLeaves: false,
        assignedLeavesToMe: true,
        upcmoingLeaveOfUser: false,
        pastLeaveOfUser: false,
        userId: null,
    }
    const response = axios.post(dashboard.TIMEOFF, data)
    return response
}

export const assignedTimeOffManager = (
    pageSize: number,
    pageNumber: number,
    userid: string,
    filters?: Filter[] | any
): Promise<any> => {
    const data: Query = {
        advancedSearch: {
            fields: [],
            keyword: '',
        },
        keyword: '',
        advancedFilter: {
            logic: 'and',
            filters: [
                {
                    field: 'ManagerUserID',
                    operator: 'eq',
                    value: userid,
                },
                {
                    field: 'IsApprovedByAssignedManager',
                    operator: 'eq',
                    value: null,
                },
                ...filters, // Include additional filters here
            ],
            field: '',
            operator: '',
            value: '',
        },
        pageNumber: pageNumber,
        pageSize: pageSize,
        orderBy: ['StartDate asc'],
        personalAppliedLeaves: false,
        assignedLeavesToMe: true,
        upcmoingLeaveOfUser: false,
        pastLeaveOfUser: false,
        userId: null,
    }
    const response = axios.post(dashboard.TIMEOFF, data)
    return response
}

export const announcementList = (
    pageSize: number,
    pageNumber: number,
    keyword: string
): Promise<any> => {
    const data = {
        pageNumber: pageNumber,
        pageSize: pageSize,
        isSeen: false,
        keyword: keyword,
    }
    const response = axios.post(dashboard.ANNOUNCEMNETS, data)
    return response
}

export const markAnnouncement = (id: string): Promise<any> => {
    const data = {
        id: id,
    }
    const response = axios.put(dashboard.MARKANNOUNCEMENT, data)
    return response
}
